import React, { FunctionComponent } from 'react';
import { Button } from 'semantic-ui-react';
import ConfirmModal from 'components/confirm-modal/confirm-modal';
import { PhoneNumber } from 'utils';
import { useIsUserAdmin } from 'hooks/use-is-user-admin/use-is-user-admin';

type ReplacePhoneNumberButtonProps = {
  phoneNumberId: number;
  phoneNumber: string;
  onReplace: (phoneNumberId: number, phoneNumber: string) => Promise<void>;
};

const ReplacePhoneNumberButton: FunctionComponent<
  ReplacePhoneNumberButtonProps
> = ({ phoneNumberId, phoneNumber, onReplace }) => {
  const isCurrentUserAdmin = useIsUserAdmin();
  if (!isCurrentUserAdmin) {
    return null;
  }

  return (
    <ConfirmModal
      trigger={
        <Button
          type="button"
          compact
          color="red"
          style={{
            padding: '2px 9px',
            marginLeft: '15px',
          }}
        >
          Remplacer
        </Button>
      }
      header="Confirmation"
      content={
        <p>
          Cette action va remplacer le numéro{' '}
          <strong>{PhoneNumber.format(phoneNumber)}</strong> en achetant un
          nouveau numéro. Continuer ?
        </p>
      }
      onConfirm={() => onReplace(phoneNumberId, phoneNumber)}
    />
  );
};

export default ReplacePhoneNumberButton;
